import { AbstractControl, ValidationErrors } from '@angular/forms';
import { CheckoutUpsellExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

export function sellingPlanValidator(group: AbstractControl): ValidationErrors | null {
  const priority = group.get('prioritizeRecommendedItemsBy')?.value;
  if (priority !== CheckoutUpsellExtension.PrioritizeRecommendedItemsBy.SELLING_PLAN) {
    return null;
  }

  const sellingPlanId = group.get('sellingPlanId')?.value;
  if (!sellingPlanId) {
    return { sellingPlanIdRequired: true };
  }

  const description = group.get('sellingPlanDescription')?.value;
  if (description && !description.includes('{price}')) {
    return { missingPricePlaceholder: true };
  }

  return null;
}
